import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "selection"]

  connect() {
    if (this.iconTargets.length !== this.selectionTargets.length) {
      if (this.application.debug) {
        console.warn("Number of icon targets does not equal the number of selection targets")
      }
    }
  }

  toggleNode(ev) {
    if (!ev.currentTarget) {
      return
    }

    [...ev.currentTarget.querySelectorAll("span")].forEach(span => {
      const index = this.iconTargets.findIndex(x => x === span)

      if (index === -1) {
        return
      }

      const selection = this.selectionTargets[index]
      const icon = this.iconTargets[index]

      if (icon && selection) {
        selection.classList.toggle("hidden")
        icon.classList.toggle("-rotate-90")
      }
    })
  }
}
